<template>
  <v-app-bar app color="white" elevation="2">
    <div class="d-flex align-center">
      <router-link to="/">
      <v-img
        alt="Logos Gemeinde Breitenbach, Laufental Thierstein Athletics, FC Breitenbach"
        class="shrink mr-2 pointer"
        contain
        src="/img/anlage-logos.jpg"
        transition="scale-transition"
        max-width="140px"
        min-width="80px"
      />
      </router-link>
    </div>
    <v-app-bar-title>Belegungsplan</v-app-bar-title>

    <v-spacer></v-spacer>

    <v-btn target="_blank" @click="triggerDialog" color="primary" dark>
      <span class="mr-2">Anlage reservieren</span>
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <FormDialog
      :show="showDialog"
      title="Anlage reservieren"
      closeText="Schliessen"
      @close="triggerDialog"
      ><ReservationForm
    /></FormDialog>
  </v-app-bar>
</template>
<script>
import FormDialog from "@/components/FormDialog";
import ReservationForm from "@/components/Form/reservationForm";

export default {
  data: () => ({
    showDialog: false,
  }),
  components: {
    FormDialog,
    ReservationForm,
  },
  methods: {
    triggerDialog() {
      this.showDialog = !this.showDialog;
    },
  },
};
</script>
